import { FC } from 'react'
import { ContactAddressType } from '../../../../../../common/ContactAddress.type'

type Props = {
  contactAddress: ContactAddressType
}

const SecondCardContent: FC<Props> = (props) => {
  const { contactAddress } = props

  return (
    <div className="switcher:short2" id="belong">
      <div>
        <span>{contactAddress.organization}</span>
        <span>
          {contactAddress.department && `(${contactAddress.department})`}
        </span>
        <span>
          {contactAddress.position && `の ${contactAddress.position}`}
        </span>
      </div>
    </div>
  )
}

export default SecondCardContent
